import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ListItem' })({
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 32,
        borderRadius: 16,
        background: '#FFF',
        padding: 24,
        boxShadow: '0px 8px 16px 0px rgba(176, 178, 186, 0.10), 0px 12px 32px 0px rgba(176, 178, 186, 0.25)',
        flexWrap: 'wrap',
        boxSizing: 'border-box',
        textDecoration: 'none'
    },
    exact: {
        border: '4px solid #FFEBED'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        flex: 3,
        maxWidth: '100%'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        whiteSpace: 'nowrap'
    },
    type: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%'
    },
    avatar: {
        width: 24,
        height: 24
    },
    dot: {
        color: '#8E8E8E',
        fontSize: 13,
        fontWeight: 200,
        lineHeight: '150%'
    },
    published: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%'
    },
    views: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%',
        '& svg': {
            width: 16,
            height: 16
        }
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3
    },
    title: {
        margin: 0,
        color: '#232323',
        fontSize: 18,
        fontWeight: 700,
        lineHeight: '150%'
    },
    description: {
        margin: 0,
        display: '-webkit-box',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '150%'
    },
    labels: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 4,
        flexWrap: 'wrap'
    },
    special: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 4,
        width: '100%'
    },
    scores: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    tags: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap'
    },
    more: {
        width: 16,
        height: 16,
        padding: 4,
        borderRadius: 8,
        border: '1px solid #ECECEC',
        cursor: 'pointer'
    }
});
